import React from 'react';
import ContactInfo from './ContactInfo';
import ContactForm from './ContactForm';

export default function Contact() {
  return (
    <section id="contact" className="py-16 lg:py-24 bg-[#2C3E50] text-[#FFF8EC] relative overflow-hidden">
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#E64B2B]/25 blur-3xl" />
      <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-[#4FB3B8]/25 blur-3xl" />
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-10 relative">
        <ContactInfo />
        <ContactForm />
      </div>
    </section>
  );
}
